import {CERTIFICATE_SUCCESS, CERTIFICATE_ERROR} from '../actions/certificate';

const initialState = {
    data: '',
    error: null
};

export default function reducer(state = initialState, action) {
    if (action.type === CERTIFICATE_SUCCESS) {
        return Object.assign({}, state, {
            data: action.data,
            error: null
        });
    } else if (action.type === CERTIFICATE_ERROR) {
        return Object.assign({}, state, {
            error: action.error
        });
    }
    return state;
}